import React from 'react';

import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Loader from 'components/UI/Loader';
import OfficePopup from 'components/Popups/OfficePopup';
import OfficesMap from './OfficesMap/OfficesMap';
import SideMenu from './SideMenu/SideMenu';
import { useOffices } from './hooks/officesHook';
import { useTrans } from 'utils/localisation';
import { withErrorBoundary } from 'components/ErrorBoundary';
import * as styles from './OurOffices.module.scss';

function OurOffices() {
  const {
    loading,
    officesList,
    isSmallScreenVersion,
    selectedOffice,
    setSelectedOffice,
    closeOfficePopupHandler,
    coordinates,
    setCoordinates,
    inViewRef,
  } = useOffices();

  const t = useTrans(['offices']);

  return (
    <Container id="offices" background="transparent" className={styles.container} ref={inViewRef}>
      {!loading ? (
        <>
          {!isSmallScreenVersion && (
            <div className={styles.mapSection}>
              <OfficesMap
                coordinates={coordinates}
                setCoordinates={setCoordinates}
                selectedOffice={selectedOffice}
                setSelectedOffice={setSelectedOffice}
                offices={officesList}
              />
              {selectedOffice && (
                <OfficePopup
                  closeHandler={closeOfficePopupHandler}
                  title={`${selectedOffice.office?.city}, ${selectedOffice.office?.country}`}
                  address={selectedOffice.office?.address}
                  phone={selectedOffice.office?.phone}
                  images={selectedOffice.office?.images}
                  className={styles.officePopup}
                />
              )}
            </div>
          )}
          <div className={styles.wrapper}>
            <div className={styles.sideMenuSection}>
              <Title tag="h2" size="h3" color="white">
                {t('title')}
              </Title>
              <SideMenu
                setCoordinates={setCoordinates}
                offices={officesList}
                selectedOffice={selectedOffice}
                setSelectedOffice={setSelectedOffice}
                isSmallScreenVersion={isSmallScreenVersion}
              />
            </div>
          </div>
        </>
      ) : (
        <Loader theme="fullHeight" />
      )}
    </Container>
  );
}

OurOffices.displayName = 'OurOffices';

export default withErrorBoundary(OurOffices);
